<template>
  <div>
    <section id="over-rijnja" class="content-wrapper page">
      <section id="" class="row header">
        <div class="col text">
          <h1>Privacyverklaring</h1>
          <p>25 oktober 2024</p>
          <p>
            Uw privacy is voor Koninklijke Rijnja BV van groot belang. Wij
            houden ons dan ook aan de relevante wet- en regelgeving over
            privacy, waaronder de Algemene Verordening Gegevensbescherming
            (verder: AVG). Dit betekent dat wij:
          </p>
          <ul>
            <li>
              <strong>Doeleinden duidelijk vastleggen,</strong> voordat wij uw
              persoonlijke gegevens verwerken, via deze privacyverklaring;
            </li>
            <li>
              <strong>Zo min mogelijk persoonlijke gegevens opslaan</strong> en
              enkel de gegevens die nodig zijn voor onze doeleinden;
            </li>
            <li>
              <strong>Expliciet toestemming vragen</strong> voor de verwerking
              van uw persoonlijke gegevens, mocht toestemming verplicht zijn;
            </li>
            <li>
              <strong>Benodigde beveiligingsmaatregelen treffen</strong> om uw
              persoonlijke gegevens te beschermen. Wij leggen deze
              verplichtingen ook op aan partijen die persoonsgegevens voor ons
              verwerken;
            </li>
            <li>
              <strong>Uw rechten respecteren,</strong> zoals het recht op
              inzage, correctie of verwijdering van uw bij ons verwerkte
              persoonsgegevens.
            </li>
          </ul>
          <p>
            Uw gegevens zijn veilig bij ons en wij zullen deze gegevens altijd
            netjes gebruiken. In deze privacyverklaring leggen we uit wat wij
            bij Koninklijke Rijnja BV allemaal doen met informatie die wij over
            u te weten komen.
          </p>
          <p>
            Als u vragen heeft of wilt weten wat wij precies van u bijhouden,
            neem dan contact op met Koninklijke Rijnja BV.
          </p>
        </div>
        <!--  <div class="col image">
          <img
            class="erkende-betrouwbaarheid"
            src="@/images/pages/erkende-betrouwbaarheid.svg"
          />
          <div class="bg-circle g-w"></div>
        </div> -->
      </section>

      <!-- <section class="row">
        <div class="col-single">
          <h1>Wat is het ISO/IEC 27001 certificaat?</h1>
          <p>
            ISO/IEC 27001 is de internationaal erkende standaard voor
            informatiebeveiliging. Met dit certificaat tonen we aan dat we
            voldoen aan de richtlijnen en algemene principes voor het initiëren,
            implementeren, handhaven en verbeteren van de informatiebeveiliging
            in onze organisatie. De norm onderschrijft dat we de
            vertrouwelijkheid, beschikbaarheid en integriteit van informatie
            binnen onze organisatie zekerstellen.
          </p>
        </div>
      </section> -->
      <section class="row">
        <div class="col text">
          <h1>Uw account</h1>

          <p>
            Bij bepaalde onderdelen van ons bedrijf moet u zich eerst
            registreren. U moet dan informatie over uzelf opgeven en een
            gebruikersnaam kiezen. Daarmee maken wij een account, waarop u kunt
            inloggen met die gebruikersnaam en een zelfgekozen wachtwoord.<br />Hiervoor
            gebruiken wij uw:
          </p>
          <ul>
            <li>Voor- en achternaam</li>
            <li>Telefoonnummer</li>
            <li>Bezorgadres en factuuradres</li>
            <li>E-mailadres</li>
          </ul>
          <p>
            Dit doen wij op basis van uw toestemming. Wij bewaren deze
            informatie, tot u het account opheft. Wij bewaren deze informatie,
            zodat u ze niet steeds opnieuw in hoeft te vullen en zodat wij u
            makkelijker kunnen benaderen als dat nodig is. U kunt via uw account
            informatie aanpassen wanneer u dat wilt. U kunt uw gegevens ook
            geforceerd laten wissen door onze IT afdeling, dit verzoek kunt u
            indienen via uw profiel instellingen.
          </p>
        </div>
        <div class="col image">
          <img class="klant" src="@/images/pages/ben-met-pc.svg" />
          <div class="bg-circle g-w"></div>
        </div>
      </section>

      <section id="" class="row reverse">
        <div class="col text">
          <h1>Afhandelen bestelling</h1>
          <p>
            Wanneer u bij ons een bestelling plaatst, gebruiken wij uw
            persoonsgegevens om deze netjes af te kunnen handelen. Wij mogen uw
            persoonsgegevens dan aan onze bezorgdienst geven om de bestelling
            bij u te laten bezorgen. Ook krijgen wij informatie over uw betaling
            van uw bank of creditcardmaatschappij.<br />Hiervoor gebruiken wij
            uw:
          </p>
          <ul>
            <li>Telefoonnummer</li>
            <li>Factuuradres</li>
            <li>E-mailadres</li>
          </ul>
          <p>
            Dit doen wij op basis van uw toestemming. Deze klantgegevens bewaren
            wij langer gekoppeld aan de orderinformatie in verband met de
            wettelijke fiscale bewaarplicht.
          </p>
        </div>
        <div class="image col">
          <img class="printstore" src="@/images/pages/printstore.svg" />
        </div>
      </section>

      <section class="row">
        <div class="col text">
          <h1>Toegang portaal</h1>
          <p>
            Met ons portaal krijgt u toegang tot een beheeromgeving waar u zelf
            dingen kunt instellen, opgeven en wijzigen voor het bedrijf. Wij
            houden bij wat u gedaan heeft en wanneer, zodat daar bewijs van
            is.<br />Hiervoor gebruiken wij uw:
          </p>
          <ul>
            <li>Telefoonnummer</li>
            <li>Factuuradres</li>

            <li>E-mailadres</li>
          </ul>
          <p>
            Dit doen wij op basis van uw toestemming. Wij bewaren deze
            informatie, tot het einde van de dienstverlening aan u.
          </p>
        </div>
        <div class="col image">
          <img class="slider" src="@/images/pages/screen-slider.svg" />
        </div>
      </section>

      <section class="row reverse">
        <div class="col text">
          <h1>Contactformulier</h1>
          <p>
            Met het contactformulier kunt u ons vragen stellen of aanvragen
            doen.<br />Hiervoor gebruiken wij uw:
          </p>
          <ul>
            <li>Telefoonnummer</li>
            <li>E-mailadres</li>
          </ul>
          <p>
            Hier hebben wij een legitiem belang bij.
          </p>
        </div>
        <div class="col image">
          <img class="form" src="@/images/pages/screen-form.svg" />
          <div class="bg-circle w-g"></div>
        </div>
      </section>

      <section class="row">
        <div class="col-single">
          <h1>Verstrekking aan andere bedrijven of instellingen</h1>
          <p>
            Met uitzondering van de partijen die nodig zijn om de hierboven
            genoemde diensten te leveren, geven wij uw persoonsgegevens onder
            geen voorwaarde aan andere bedrijven of instellingen, behalve als
            wij dat wettelijk verplicht zijn (bijvoorbeeld als de politie dat
            eist bij een vermoeden van een misdrijf).
          </p>
        </div>
        <!--  <div class="col image">
          <img class="checklist" src="@/images/pages/checklist.svg" />
        </div> -->
      </section>
      <section class="row">
        <div class="col text">
          <h1>Statistieken</h1>
          <p>
            Wij houden statistieken bij over het gebruik van onze website. Meer
            informatie hierover vindt u hier:
            <a
              href="https://support.google.com/analytics/answer/6004245?hl=nl"
              class="link-text"
              >Google Analystics</a
            >
          </p>
        </div>
        <div class="col image">
          <img class="stats" src="@/images/pages/stats-screen.svg" />
        </div>
      </section>
      <section class="row reverse">
        <div class="col text">
          <h1>Cookies</h1>
          <p>
            Rijnja.nl gebruikt cookies. Cookies zijn kleine bestandjes waar we
            informatie in kunnen opslaan, zodat u die niet steeds hoeft in te
            vullen. Maar wij kunnen er ook mee zien dat u ons weer bezoekt. Meer
            informatie over het gebruik van cookies vindt u in ons
            <router-link class="link-text" to="/cookiebeleid"
              >cookiebeleid.</router-link
            >
          </p>
        </div>
        <div class="col image">
          <img class="cookies" src="@/images/pages/cookies.svg" />
        </div>
      </section>

      <section class="row">
        <div class="col text">
          <h1>Beveiliging</h1>
          <p>
            Beveiliging van persoonsgegevens is voor ons van groot belang. Om uw
            privacy te beschermen, nemen wij de volgende maatregelen:
          </p>
          <ul>
            <li>
              Toegang tot persoonsgegevens wordt afgeschermd met een
              gebruikersnaam en wachtwoord
            </li>
            <li>
              De gegevens worden na ontvangst opgeslagen in een apart,
              afgeschermd systeem
            </li>
            <li>
              Wij nemen fysieke maatregelen zoals sloten en kluizen voor
              toegangsbescherming van de systemen waarin persoonsgegevens
              opgeslagen zijn
            </li>
            <li>
              Wij maken gebruik van beveiligde verbindingen (Secure Sockets
              Layer of SSL) waarmee alle informatie tussen u en onze website
              wordt afgeschermd wanneer uw persoonsgegevens invoert
            </li>
            <li>
              Wij houden logs bij van alle opvragingen van persoonsgegevens
            </li>
          </ul>
        </div>
        <div class="col image">
          <img class="security" src="@/images/pages/security.svg" />
        </div>
      </section>

      <section class="row">
        <div class="col-single">
          <h1>Bewaartermijn documenten</h1>
          <p>
            De door u geüploade documenten ter verwerking van de order worden
            opgeslagen op ons centrale bestandssysteem in een datacenter in
            Nederland en enkel naar de producerende vestiging gestuurd op het
            moment dat de order daadwerkelijk wordt verwerkt. Uw bestanden die
            gekoppeld zijn aan de order worden niet langer dan 3 maanden bewaard
            op onze systemen. Na 6 maanden zijn de bestanden ook uit alle
            back-up systemen verdwenen. Indien u uw bestanden wilt wissen dan
            kunt u dat aangeven bij de orderoverzichtpagina. Indien gewenst is
            er voor uw organisatie ook een “secured printing” optie mogelijk
            waarmee de omgang met bestanden per workflow kan worden afgestemd.
          </p>
        </div>
      </section>

      <section class="row reverse">
        <div class="col text">
          <h1>Functionaris voor gegevensbescherming</h1>
          <p>
            Wij hebben een zogeheten functionaris voor gegevensbescherming
            aangesteld. Deze persoon is verantwoordelijk voor de privacy binnen
            onze organisatie. Onze functionaris voor gegevensbescherming is
            bereikbaar per e-mail op privacy@rijnja.nl en per telefoon op 030
            284 93 00 voor al uw vragen en verzoeken.
          </p>
        </div>
        <div class="col image">
          <img
            class="security"
            src="@/images/pages/erkende-betrouwbaarheid.svg"
          />
        </div>
      </section>

      <section class="row">
        <div class="col-single">
          <h1>Wijzigingen in deze privacyverklaring</h1>
          <p>
            Wanneer onze website wijzigt, moeten wij natuurlijk ook de
            privacyverklaring aanpassen. Let dus altijd op de datum hierboven en
            kijk regelmatig of er nieuwe versies zijn. Wij zullen ons best doen
            wijzigingen aan u door te geven.
          </p>
        </div>
      </section>

      <section class="row">
        <div class="col text">
          <h1>Uw rechten</h1>
          <p>
            Als u vragen heeft of wilt weten welke persoonsgegevens wij van u
            hebben, kunt u altijd contact met ons opnemen. Zie de
            contactgegevens hieronder.
          </p>
          <p>U hebt de volgende rechten:</p>
          <ul>
            <li>
              Uitleg krijgen over welke persoonsgegevens wij hebben en wat wij
              daarmee doen;
            </li>
            <li>Inzage in de precieze persoonsgegevens die wij hebben;</li>
            <li>Het laten corrigeren van fouten;</li>
            <li>Het laten verwijderen van verouderde persoonsgegevens;</li>
            <li>
              Het laten overdragen van persoonsgegevens aan een andere partij;
            </li>
            <li>Intrekken van toestemming;</li>
            <li>Een bepaalde verwerking beperken;</li>
            <li>Bezwaar maken tegen een bepaald gebruik.</li>
          </ul>
          <p>
            Let op dat u altijd duidelijk aangeeft wie u bent, zodat we zeker
            weten dat wij geen gegevens van de verkeerde persoon aanpassen of
            verwijderen. Wij zullen in principe binnen een maand aan uw verzoek
            voldoen. Deze termijn kan echter worden verlengd om redenen die
            verband houden met de specifieke rechten van betrokkenen of de
            complexiteit van het verzoek. Als wij deze termijn verlengen, zullen
            wij u daarvan tijdig op de hoogte stellen.
          </p>
        </div>
        <div class="col image">
          <img class="checklist" src="@/images/pages/checklist-green.svg" />
        </div>
      </section>

      <section class="row">
        <div class="col-single">
          <h1>Klacht indienen</h1>
          <p>
            Als u een klacht in wilt dienen over het gebruik van uw
            persoonsgegevens kunt u een e-mail sturen naar privacy@rijnja.nl.
            Wij pakken elke klacht intern op en communiceren dit verder met u.
          </p>
          <p>
            Als u vindt dat wij u niet op de juiste manier helpen, dan heeft u
            het recht om een klacht in te dienen bij de toezichthouder. Deze
            heet de Autoriteit Persoonsgegevens.
          </p>
        </div>
      </section>

      <section class="row">
        <div class="col-single">
          <h1>Contactgegevens</h1>
          <p>
            Koninklijke Rijnja BV<br />
            Ravenswade 2B<br />
            3439 LD Nieuwegein<br />
            E-mailadres: privacy@rijnja.nl<br />
            Telefoon: 0302849300
          </p>
          <p>
            KvK nummer: 30097260
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import SiteFooter from '../../components/SiteFooter.vue'
export default {
  components: { SiteFooter }
}
</script>

<style lang="scss" scoped>
h1 {
}
.erkende-betrouwbaarheid {
  max-width: 425px;
}

.security {
  max-width: 425px;
}

.checklist {
  max-width: 390px;
}

.printstore {
  max-width: 365px;
}

.klant {
  max-width: 350px;
}

.slider,
.stats,
.form {
  max-width: 250px;
}

.cookies {
  max-width: 320px;
}
</style>
